<script lang="ts">
  import TailwindCss from "./TailwindCSS.svelte";
  // import Claim from "./Claim.svelte";
  // import Claimed from "./Claimed.svelte";
  import Login from "./Login.svelte";
  // import Send, { getModal } from "./Send.svelte";
  // import List from "./List.svelte";
  import Toast from "./Toast.svelte";
  document.body.style.padding = "0";
</script>

<main class="bg-gray-100 h-screen">
  <Toast />
  <!-- <Claim /> -->
  <!-- <List /> -->
  <Login />
</main>
